import type { IconButtonProps as ChakraIconButtonProps } from '@chakra-ui/react'
import { IconButton as ChakraIconButton } from '@chakra-ui/react'
import * as React from 'react'

export interface IconButtonProps extends ChakraIconButtonProps {
  /**
   * Accessible name — REQUIRED. Icon-only buttons have no visible text, so
   * without this screen-reader users get no indication of what the button does
   * (WCAG 4.1.2). Prefer an i18n value, e.g. `aria-label={t('global:close')}`.
   */
  'aria-label': string
}

/**
 * Drop-in replacement for Chakra's `IconButton` that makes `aria-label`
 * mandatory at the type level. Use this instead of importing `IconButton`
 * straight from `@chakra-ui/react` so unlabelled icon buttons can't ship.
 */
export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => <ChakraIconButton ref={ref} {...props} />
)

IconButton.displayName = 'IconButton'
